import cx from 'classnames';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React, {useCallback} from 'react';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';

import './ColorUnit.sass';

export const ColorUnit = ({
  color,
  height = 32,
  width = 32,
  onClick,
  square = false,
  isActive,
  dataQaId,
  disabled = false,
}) => {
  const isLargishAndUp = useIsLargishAndUp();
  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const onClickHandler = useCallback(() => {
    if (onClick) onClick(color);
  }, [onClick]);

  return (
    <button
      type="button"
      className={cx('unstyled-button colors_unit', {
        'colors_unit--clickable': onClick,
        'colors_unit--square': square,
        'colors_unit--active': isActive,
        'colors_unit--disabled': disabled,
        'colors_unit--mobile': !isLargishAndUp,
      })}
      style={{backgroundColor: color, height, width}}
      aria-label={color}
      onClick={disabled ? undefined : onClickHandler}
      data-qa-id={dataQaId}
    />
  );
};
